import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { TIMELINE } from '@/_core/endpoint'
import apiRequestManager from '@/_core/apiRequestManager'

export const useTimelineStore = defineStore('timeline', () => {
  const context: Timeline = reactive({
    items: [],
    isFetching: false,
  })

  const getTimelineItem = (id: string) => {
    return context.items.find(item => item.comment.id === id)
  }

  const fetchTimeline = async () => {
    context.isFetching = true

    try {
      await apiRequestManager.handleRequest({
        endpoint: TIMELINE,
        callback: (response: any, isSuccess: boolean) => {
          if (isSuccess) {
            context.items = response.data.data.map((resItem: TimelineResponseItem) => {
              return {
                /**
                 * コメント情報
                 */
                comment: {
                  id: resItem.comment.id,

                  // 本文
                  body: resItem.comment.body,

                  // コメント日付（サーバ側から +09:00 されて返ってこないのでフロント側で +09:00 すること）
                  date: resItem.comment.created_at,

                  // タイムラインアイテム種別
                  type: resItem.comment.type,

                  // いいね情報
                  liked: {
                    count: resItem.comment.liked_count,
                    byMe: resItem.comment.liked_by_me,
                  },

                  // コメントユーザー情報
                  user: {
                    // ユーザー名（フルネーム）
                    name: resItem.comment.contributor.name,

                    // ユーザー名（かな）
                    phoneticName: resItem.comment.contributor.phonetic_name,

                    // ユーザーの一言コメント（マイページで設定するやつ）
                    message: resItem.comment.contributor.comment,

                    // ユーザーの所属会社名
                    companyName: resItem.comment.contributor.company_name,

                    // 部署・役職
                    positionName: resItem.comment.contributor.position_name,

                    // ユーザーの経歴文章（マイページで設定するやつ）
                    introduction: resItem.comment.contributor.introduction,

                    // ユーザーのアバター画像
                    avatarUrl: resItem.comment.contributor.image_url,
                  },
                },

                /**
                 * コメント対象コンテンツ情報
                 */
                content: {
                  // 対象記事 ID
                  id: resItem.id,

                  // 対象記事タイトル
                  title: resItem.title,

                  // 対象記事種別（report, headline...）
                  type: resItem.type,

                  // 対象記事種別の日本語ラベル（オリジナル、ニュース...）
                  typeLabel: resItem.type_name,

                  // 対象記事サムネイル画像
                  thumbImageUrl: resItem.thumbnail_url,

                  // 対象記事 URL
                  to: resItem.url,

                  /**
                   * 対象記事公開者
                   */
                  publisher: {
                    // 公開者の会社ロゴ画像
                    iconUrl: resItem.publisher_icon_url,

                    // 公開者の名義（会社名）
                    name: resItem.publisher_name,
                  },

                  // 対象記事のボリューム（第何編）
                  vol: resItem.vol,

                  /**
                   * コメント
                   */
                  comment: {
                    // 対象記事へのコメント総数
                    total: resItem.comment_count,
                  },
                },
              }
            })
          }
        }
      })
    } catch (error) {
      console.error(error)
    } finally {
      context.isFetching = false
    }
  }

  return {
    // data
    context,

    // methods
    getTimelineItem,
    fetchTimeline,
  }
})
